import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeModule } from './module/home/home.module';
import { HelperModule } from './shared/helper/helper.module';
import { StorageModule } from './shared/storage/storage.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedComponentModule } from './shared/component/shared-component.module';
import { ModelModule } from './shared/data/model.module';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ResultComponent } from './shared/component/modal/result/result.component';
import { APP_BASE_HREF } from '@angular/common';
import { environment } from 'src/environments/environment';
import { PageUnauthorizedComponent } from './module/page-unauthorized/page-unauthorized.component';

@NgModule({
  declarations: [
    AppComponent,
    PageUnauthorizedComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    SharedComponentModule,
    ModelModule,
    NgbModule,
    StorageModule,
    HelperModule,
    HomeModule
  ],
  providers: [NgbActiveModal, { provide: APP_BASE_HREF, useValue: environment.baseUrl }],
  bootstrap: [AppComponent],
  entryComponents: [
    ResultComponent
  ]
})
export class AppModule { }
